import config from '../config.json'
const isEncryptionEnabled = String(process.env.REACT_APP_IS_ENCRYPTION_ENABLED).trim().toLowerCase() === "true";

const uatBaseURL = isEncryptionEnabled === true ? "https://aointakeuatapi-apim.azure-api.net/LPL" : "https://aointakeuatapi.azurewebsites.net";
const prodBaseURL = isEncryptionEnabled === true ? "https://aointakeapi-apim.azure-api.net/LPL" : "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";
export const BASE_URL = (config.demo)? uatBaseURL : prodBaseURL;

export const BASE_URL_New = (config.demo)? "https://aointakeuatapi.azurewebsites.net": "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";
export const AoPaymentUrl = (config.demo) ? 'https://aopaymentdev.agingoptions.com/' : "https://aopayment.azurewebsites.net/";

const uatPaymentDirectUrl = 'https://aopaymentdev.agingoptions.com';
const prodPaymentDirectUrl = 'https://aopayment.azurewebsites.net';
const uatPaymentApimUrl = 'https://aopaymentdev-apim.azure-api.net/LPL';
const prodPaymentApimUrl = 'https://aopayment-apim.azure-api.net/LPL';
export const AoPaymentApiUrl = (config.demo)
  ? (isEncryptionEnabled === true ? uatPaymentApimUrl : uatPaymentDirectUrl)
  : (isEncryptionEnabled === true ? prodPaymentApimUrl : prodPaymentDirectUrl);
export const AoPaymentReturnUrl = (config.demo) ? "https://universalpaymentuat.agingoptions.com" : "https://universalpayment.agingoptions.com";
export const intakeBaseUrl = (config.demo) ? 'https://aointakeformuat.agingoptions.com/' : 'https://member.intake.agingoptions.com/';
export const AoLoginUrl = (config.demo) ? 'https://aologinuat.agingoptions.com/account/Signin' : 'https://unilogin.agingoptions.com/account/signin';
export const AoAdminBaseUrl = (config.demo)?'https://Aoadminuat.agingoptions.com/': 'https://AOAdmin.agingoptions.com/';
export const AoAgenturl = (config.demo) ? 'https://aoagentuat.agingoptions.com/' : 'https://agent.agingoptions.com/';
export const CounterBaseUrl =  (config.demo)?"https://aoeventcounteruat.agingoptions.com/": "https://Event.counter.agingoptions.com/";
export const CounterMobileBaseUrl = (config.demo)?"https://aoeventcountermobileuat.agingoptions.com/": "https://event.mcounter.agingoptions.com/";
export const IntakeEntryBaseUrl =    (config.demo)?"https://intakeentryformuat.azurewebsites.net/": "https://intakeentryform.azurewebsites.net/";;


let AoUrl = {
   get_UserbyName:BASE_URL+'/api/2/Paralegal/GetClientListBySubtenantId',
   addNewUserdata: BASE_URL+"/api/User/AddUser",
   getUserServices: BASE_URL+"/api/Subscription/",
   getContactByUserId: BASE_URL+"/api/Contact/get-contact-by-userid/",
   updateContactByUserId: BASE_URL+"/api/Contact/update-contact-by-userid/",
   postAddUserOrder:BASE_URL+'/api/UserOrder/AddUserOrder/',
   confirmUserOrder:BASE_URL+'/api/UserOrder/ConfirmUserOrder/',
   getUserListByRoleId:BASE_URL+'/api/User/getUserListByRoleId',
   getuserSubs :BASE_URL + "/api/UserAuthSubs/",
   getSubjectResponse: BASE_URL + "/api/Subject/get-user-subject/",
   getUserActivationLink:BASE_URL+'/api/UserActivation/GetUserActivationLink',
   // getUserList:BASE_URL+'/api/User/getUserList',
   upserUserAuthSubs:BASE_URL + "/api/UserAuthSubs/upsert-UserAuthSubs",
   getMemberDetails: BASE_URL + "/api/Member/",
   putUpdateMember: BASE_URL + "/api/Member/update-member-by-id",
   putUpdateMemberEmail: BASE_URL + "/api/Account/UpdateUserName",
   getTenantslist: BASE_URL+ "/api/Tenant/GetTenants/",
   upsertTenantdata: BASE_URL+"/api/Tenant/UpsertTenant",
   // getDocMembersByParalegalId: BASE_URL + "/api/2/Paralegal/getDocMembersByParalegalId",
   getOrderDetailbySubtenantId: BASE_URL+'/api/Records/GetOrderDetailbySubtenantId',
   getFinancecalculation:'/api/LegalCompensation/GetFinanceCalculation',
   getUserLegalStaff:'/api/UserLegalStaff/GetUserLegalStaff',
   upsertUserLegalStaff:'/api/UserLegalStaff/Upsert-UserLegalStaff',
   get_UserProfileDetailsByUserId:BASE_URL+'/api/UserProfile/GetUserProfileByUserId/',
   postuserSubscriptionCancel: BASE_URL + "/api/UserSubscriptions/CancelSubscription/",
   postCardVerify: AoPaymentApiUrl + '/Catalog/CheckCreditCard',
   postSyncUserCardInfo: BASE_URL + '/api/UserProfile/SyncUserCardInfo',
   getUserSubscription: BASE_URL + "/api/UserSubscriptions/",
   addUserSubscription: BASE_URL + "/api/UserSubscriptions/add/",
   updateUserSubscription: BASE_URL + "/api/UserSubscriptions/update",
   getSubscriptionDetails: BASE_URL + "/api/Subscription/Details/",
   getUserSubscriptionPlansAsync: BASE_URL + "/api/UserSubscriptionPlans/GetUserSubscriptionPlansAsync",
   upsertUserSubscriptionPlans: BASE_URL + "/api/UserSubscriptionPlans/upsert",
   post_CreateUserRecurringSubscription:BASE_URL+'/api/UserSubscriptions/CreateUserRecurringSubscription',
   getGetOrderInfo:'/api/UserOrder/GetOrderInfo/',
   uploadFileurl:'/api/2/FileUpload/uploadUserDocuments',
   getFileCabinetFolderDetails:BASE_URL+ "/api/2/FileCabinet/GetFileCabinetFolderDetails",
   upsertCabinetFolder:BASE_URL+ '/api/2/FileCabinet/UpsertFileCabinetFolder',
   addfiletoFilecabinet:BASE_URL+'/api/2/UserFileCabinet/Add',
   getAthenticatePath: BASE_URL + '/api/2/User/AuthenticateLoggedInUser',
   getUserDetailByEmailId: BASE_URL + '/api/Account/GetUserDetailByEmailId?',
   getSubtenantDetails: BASE_URL + '/api/Subtenant/get-subtenant-details',
   getUserRoles: BASE_URL + '/api/UserRoles/getRoles',
   postOtpData: BASE_URL + '/api/OTP/Validate-OTP-For-NewUser',
   postSendOtp: BASE_URL + '/api/OTP/Send-OTP-To-User',
   postResendOtp: BASE_URL + '/api/OTP/ReSend-OTP-To-User',
   getCommMediumPath: BASE_URL + '/api/CommMedium/GetCommMedium',
   GetEmailTemplate: BASE_URL + "/api/EmailTemplates/GetEmailTemplates",
   PostEmailCom: BASE_URL + "/api/EmailComm/SendEmailComm",
   getTextTemplate: BASE_URL + "/api/TextTemplates/GetTextTemplates",
   postSendTextPath: BASE_URL + '/api/TextComm/SendText',
    sentEmailWithAsyncCcBc:BASE_URL+'/api/EmailComm/SendEmailWithCCnBccAsync',
   GetClientDetailsByUserId: BASE_URL + '/api/2/Paralegal/GetClientDetailsByUserId/',
   postsubtenantcreateUser: '/api/User/CreateUser',
   postRoleIdAPI: '/api/UserRole/AddRoleAsync/',
   putRoleIdAPI: '/api/UserRole/UpdateRoleAsync/',
   postspeakerupsertuser: '/api/SpeakerUser/upsert-SpeakerUser',
   getCitizenshipTypePath: 'api/CitizenshipType',
   getcountrycodepath: '/api/Country/GetRegistrationEnableCountry',
   postsubtenantusermemberupdate: '/api/Member/update-member-by-id/',
   postaddressbyuserid: '/api/Address/add-address-by-userid',
   postfileuploadspeaker: '/api/FileUpload/uploadUserDocuments',
   getExceldataurl: '/api/Records/GetSubtenantsOrderDetail',
   GetFeedbackPriority:'/api/FeedbackPriority/GetFeedbackPriority',
   fileUploadPath: "/api/FileUpload/uploadUserDocuments",
   postFeedback: "/api/Feedback/add-feedback",
   sendPostEmailCC:'/api/EmailComm/SendEmailWithCCAsync',
   sendMailFeedBack:'/api/EmailComm/SendEmailToMultipleNAttachmentAsync',
   sourceTypeapi: '/api/UserAuthSubs/GetSourceType',
   addOtherPath: "/api/Others/add-others",
   mapOtherwithFormPath: "/api/MemberOthersMap/add-member-othersmap",
   getOtherFromAPI: "/api/MemberOthersMap/get-member-othersmap",
   updateOtherPath: "/api/Others/update-others",

   getModuleConnecturl:'/api/ModuleConnection',

   postAddUserAuthSubsInsurl:'/api/UserAuthSubs/AddUserAuthSubsIns',
   postrefundrequest:'/api/UserOrder/CreateRefundRequest',
   getRefundrequesturl:'/api/UserOrder/GetRefundRequest',
   updateRefundrequesturl:'/api/UserOrder/UpdateRefundRequest',
   updateOrderurl:'/api/UserOrder/UpdateOrder',
   getDateViaCalenderDates:'/api/2/UserOrder/getDocMembersByParalegalId',
   getClientOrderList:'/api/2/UserOrder/GetClientOrderList',
   updateRefundPaymenturl:'/api/UserOrder/AcceptRefundGeneral',
   updateRefundPayment:'/api/UserOrder/AcceptRefund',
   updateTransferPayment:'/api/UserOrder/TransferAmount',
   checkTransactionStatusurl:'api/UserOrder/CheckTransactionStatus',
   withdrawnAmounturl:'/api/UserOrder/CreateWithdrawFromAccount',
   getAttorneyReportAsync:'/api/UserOrder/GetAttorneyReportAsync',
   // getARDeptReportAsync:'/api/UserOrder/GetDepartReportAsync',
   getARDeptReportAsync: BASE_URL + '/api/UserOrder/GetDepartReportAsync',
   CancelUserAuthSub: BASE_URL + '/api/UserAuthSubs/CancelUserAuthSub',
   GetClientBySubtenantId:BASE_URL +'/api/2/Paralegal/GetClientBySubtenantId',
   GetClientARDetailsByUserId:BASE_URL +'/api/2/Paralegal/GetClientARDetailsByUserId',
   CreateModifySubsRequest:BASE_URL+ '/api/UserAuthSubs/CreateModifySubsRequest',
   GetModifySubsRequest:BASE_URL+'/api/UserAuthSubs/GetModifySubsRequest',
   UpdateModifySubsRequest:BASE_URL+'/api/UserAuthSubs/UpdateModifySubsRequest',
}

export default AoUrl;